(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('cfiApp')
        .constant('CFI_CONST', {
        	'REQUEST_TYPE_CODE': 'PS-05',
            'REQUEST_SUB_TYPE_NAME': 'Hủy hợp đồng trong thời gian cân nhắc',
            'REQUEST_TYPE_NAME': 'Điều chỉnh hợp đồng',
            'REQUEST_SUB_TYPE_CODE': 'PS-SUB-112',
        })
        
})();